export const LogoMark = ({ className = "h-11 w-11" }) => (
  <img
    src="/logo-256.png"
    alt="Logo Angélivraisons"
    className={`${className} rounded-full object-cover shadow-sm ring-1 ring-ink/10`}
  />
);

export const LogoBig = ({ className = "h-24 w-24" }) => (
  <img
    src="/logo-512.png"
    alt="Angélivraisons — Services & livraisons"
    className={`${className} rounded-full object-cover shadow-lg shadow-ink/10 ring-1 ring-ink/10`}
    data-testid="logo-big"
  />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" data-testid="nav-brand-logo">
    <LogoMark />
    <span className={`font-serif text-2xl font-semibold tracking-tight ${dark ? "text-cream" : "text-forest"}`}>
      Angé<span className="text-terra">livraisons</span>
    </span>
  </span>
);
